export default class fbListFilterCtrl {
  constructor($element, $timeout, FactQuery) {
    this.element = $element[0]
    this.timeout = $timeout

    this.factQuery = FactQuery
  }
  $onInit() {
    /*
      Called on each controller after all the controllers on an element 
      have been constructed and had their bindings initialized 
      (and before the pre & post linking functions for the directives on this 
      element). This is a good place to put initialization code for your controller.
    */
    this.reset()
  }
  $onDestroy() {
    /*
      Called on a controller when its containing scope is destroyed. 
      Use this hook for releasing external resources, watches and event handlers.
    */

  }
  $postLink() {
    /*
      Called after this controller's element and its children have been linked. 
      Similar to the post-link function this hook can be used to set up 
      DOM event handlers and do direct DOM manipulation. Note that child 
      elements that contain templateUrl directives will not have been compiled 
      and linked since they are waiting for their template to load 
      asynchronously and their own compilation and linking has been suspended 
      until that occurs. This hook can be considered analogous to the 
      ngAfterViewInit and ngAfterContentInit hooks in Angular 2. Since the 
      compilation process is rather different in Angular 1 there is no direct 
      mapping and care should be taken when upgrading.
    */
  }
  $onChanges(changesObj) {
    /*
      Called whenever one-way bindings are updated. The changesObj is a hash 
      whose keys are the names of the bound properties that have changed, and 
      the values are an object of the form 
      { currentValue, previousValue, isFirstChange() }. 
      Use this hook to trigger updates within a component such as cloning the 
      bound value to prevent accidental mutation of the outer value.
    */
    this.setHeight()
  }
  setHeight() {
    // subtract the input height from the generic filter body height
    this.listHeight = this.height &&
      `${parseInt(this.height.replace('px','')) - 28.75}px`
  }
  reset() {
    this.value = ''
  }
  submit() {
    if (this.value) {
      let key = this.excludeMode ? 'excludes' : 'includes'
      this.list[key] = this.list[key] || []
      this.list[key].push(this.value)

      this.update()
    }


  }
  getIndex() {
  return this.factQuery.data.filterPipeline
    .map(f => f.attribute).indexOf(this.list.attribute)
  }

  update() {
    let i = this.getIndex()
    this.factQuery.data.filterPipeline[i] = this.list;

    this.factQuery.api.update().then(() => {
      this.reset()
    })
  }
  remove(item, key) {
    let i = this.list[key].indexOf(item)
    this.list[key].splice(i, 1)
    if (this.list[key].length === 0) {
      // set empty state for key
      this.list[key] = key === 'excludes' ? [] : null
    }
    this.update()
  }
  clear() {
    this.list.includes = null
    this.list.excludes = []

    this.update()
  }
  handleSubmit(e) {
    e.stopImmediatePropagation()
    e.preventDefault()
    switch (e.keyCode) {
      case 27:
        this.reset()
        break
      case 13:
        this.submit()
        break;
    }
  }
}
fbListFilterCtrl.$inject = ['$element', '$timeout', 'FactQuery']



// WEBPACK FOOTER //
// ./project/components/fb-list-filter/fb-list-filter.controller.js